import { Component, OnInit, ViewChild } from '@angular/core';
import * as ngswal from "sweetalert";
import { Local } from 'protractor/built/driverProviders';
import { ApiMethod } from '../apimethods/api-method';
import { DataParam, customfunctions } from '../common/customfunctions';
import { GlobalConstants } from '../common/global-constants';
import { weightageRolewiseModel } from './weightage-rolewisemodel';

declare var $;


@Component({
  selector: 'app-weightage-rolewise',
  templateUrl: './weightage-rolewise.component.html',
  styleUrls: ['./weightage-rolewise.component.css']
})
export class weightagerolewiseComponent implements OnInit {

  modelItem = new weightageRolewiseModel();
  dataTable: any; @ViewChild('dataTable', { static: false }) table; dataSet: any;
  title: string;
  popupButtonText: string;
  showModal: boolean;
  RoleList: any;
    username: string;

  ngOnInit() {


  }

  constructor() {
    ApiMethod.getPageConfig().subscribe(
      data => {
        this.modelItem = <weightageRolewiseModel>data["weightageRolewisePage"];


        $('#ddlRoleType').select2({
          placeholder: "Select Role",
          dropdownParent: "#btnPopupartDetails"
        });
        $('#ddlRoleType').val([]).trigger('change');



        this.GetRoleList();
        this.GetweightageuserwiseData();

      }, error => {
        ngswal("Warning !", error.message, "warning");
      });
  }



  //Get RoleList
  GetRoleList(): void {
    ApiMethod.getMethod(this.modelItem.RoleListAPI).subscribe(
      result => {
        this.RoleList = result.aitemList;
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Warning !", error, "warning");
      });
  }



  GetweightageuserwiseData(): void {

    $("#LoadingImage").show();
    var dataParam = {
      LoginId: localStorage.aLoginID,
      PublisherId: localStorage.aPubID,
      ModuleName: "WeightageRolewiseConfig"
    }
    ApiMethod.postMethod(this.modelItem.weightageRolewiseListAPI, dataParam).subscribe(
      result => {

        this.dataSet = JSON.stringify(result.aitemList); // Data List
        this.dataSet = JSON.parse(this.dataSet);
        this.dataTable = $(this.table.nativeElement);

        //Dynamic datable
        let aColList = result.acolListL; // grid column data
        let dataItem = new DataParam();
        dataItem.acolList = aColList;
        dataItem.dataTable = this.dataTable;
        dataItem.dataset = this.dataSet;
        dataItem.dtheight = (GlobalConstants.size.height - 150);
        dataItem.modulename = 'WeightageRolewiseConfig';
        dataItem.aNewButtonName = 'BtnPopup';
        dataItem.isDefault = false;
        this.dataTable = customfunctions.dynamicDataTable(dataItem);
        //Dynamic datable

        $("#LoadingImage").hide();

      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "warning");
      });
  }

  //Show Publisher details by ID
  showWeightageRolewise(): void {
    $("#btnPopupartDetails").show();
    this.ClearData();

    if (localStorage.aEID && localStorage.aEID !== "0") {
      this.popupButtonText = "Update";
      $("#LoadingImagePopup").show();

      ApiMethod.getMethod(this.modelItem.weightageRolewiseIDAPI + '/' + localStorage.aEID).subscribe(
        result => {
          $("#LoadingImagePopup").hide();
          const aitems = result.aitemList;

          if (aitems && aitems.length > 0) {
            const data = aitems[0];

            // Set Role dropdown and trigger change
            $("#ddlRoleType").val(data.RoleId).change();

            // Set Weightage performance fields
            $('#Txt_NonProduction').val(data.NonProduction);
            $('#Txt_ProductivityAchieved').val(data.ProductivtyAchieved);
            $('#Txt_Occupancy').val(data.Occupancy);
            $('#Txt_Punctuality').val(data.Punctuality);
            $('#Txt_Attendance').val(data.Attendance);
            $('#Txt_TotalSum').val(data.TotalSum);

            // Set Range performance fields
            $('#Txt_PoorRange').val(data.PoorRange);

            if (data.ModerateRange?.includes('–')) {
              const [modStart, modEnd] = data.ModerateRange.split('–');
              $('#Txt_ModerateStart').val(modStart);
              $('#Txt_ModerateEnd').val(modEnd);
            }

            if (data.GoodRange?.includes('–')) {
              const [goodStart, goodEnd] = data.GoodRange.split('–');
              $('#Txt_GoodStart').val(goodStart);
              $('#Txt_GoodEnd').val(goodEnd);
            }

            $('#Txt_ExcellentRange').val(data.ExcellentRange);

            // Delay to ensure DOM update before reading selected text
            setTimeout(() => {
              const atitle = $("#ddlRoleType option:selected").text();
              this.title = `Update Weightage Rolewise Config`;
              this.username = atitle;
            }, 0);
          }
        },
        error => {
          $("#LoadingImagePopup").hide();
          ngswal("Failed !", error.error.Message, "warning");
        }
      );
    } else {
      this.popupButtonText = "Save";
      this.title = "Add Weightage Rolewise Config";
      this.username = '';
    }
  }

  calculateTotal(lastFieldId: string): void {
    const fields = [
      'Txt_Occupancy',
      'Txt_Punctuality',
      'Txt_Attendance',
      //'Txt_LD_Training',
      //'Txt_APQC_Skills',
      //'Txt_DeliverRCA_Skills'
    ];

    let total = 0;
    let allFieldsFilled = true;

    // First calculate total normally
    for (let fieldId of fields) {
      const input = document.getElementById(fieldId) as HTMLInputElement;
      if (input && input.value.trim() !== '') {
        const value = parseFloat(input.value);
        total += isNaN(value) ? 0 : value;
      } else {
        allFieldsFilled = false;
      }
    }

    const totalField = document.getElementById('Txt_TotalSum') as HTMLInputElement;
    const lastInput = document.getElementById(lastFieldId) as HTMLInputElement;

    // If there's an error
    if (total > 100 || (allFieldsFilled && total < 100)) {
      // Remove the last entered value
      if (lastInput) lastInput.value = '';

      // Recalculate total without the last field
      let newTotal = 0;
      for (let fieldId of fields) {
        if (fieldId === lastFieldId) continue;
        const input = document.getElementById(fieldId) as HTMLInputElement;
        if (input && input.value.trim() !== '') {
          const value = parseFloat(input.value);
          newTotal += isNaN(value) ? 0 : value;
        }
      }

      // Set the new total
      if (totalField) totalField.value = newTotal.toFixed(2);

      // Show warning
      ngswal("Warning !", total > 100 ? " Occupancy + Punctuality + Attendance must equal 100!" : " Occupancy + Punctuality + Attendance must equal 100!", "warning");
      return;
    }

    // If no error, update total as normal
    if (totalField) {
      totalField.value = total.toFixed(2);
    }
  }


  updateRanges(): void {
    const poorInput = document.getElementById('Txt_PoorRange') as HTMLInputElement;
    const modStart = document.getElementById('Txt_ModerateStart') as HTMLInputElement;
    const modEnd = document.getElementById('Txt_ModerateEnd') as HTMLInputElement;
    const goodStart = document.getElementById('Txt_GoodStart') as HTMLInputElement;
    const goodEnd = document.getElementById('Txt_GoodEnd') as HTMLInputElement;
    const excellentInput = document.getElementById('Txt_ExcellentRange') as HTMLInputElement;

    const poorValue = parseFloat(poorInput?.value || '0');
    const modEndValue = parseFloat(modEnd?.value || '0');
    const excellentValue = parseFloat(excellentInput?.value || '0');

    // Clamp values to 0-100 range
    poorInput.value = Math.min(poorValue, 100).toString();
    modEnd.value = Math.min(modEndValue, 100).toString();
    excellentInput.value = Math.min(excellentValue, 100).toString();

    // Set Moderate Start = Poor Range
    modStart.value = !isNaN(poorValue) ? poorValue.toString() : '';

    // Set Good Start = Moderate End
    goodStart.value = !isNaN(modEndValue) ? modEndValue.toString() : '';

    // Set Good End = Excellent Range
    goodEnd.value = !isNaN(excellentValue) ? excellentValue.toString() : '';
  }



  //Update Weightage Rolewise details
  UpdateWeightageRolewise(): void {
    // Validate RoleType
    if ($('#ddlRoleType').val() == null) {
      ngswal("Warning !", "Enter Role name!", "warning");
      return;
    }

    // Validate NonProduction
    //if ($('#Txt_NonProduction').val() == '') {
    //  ngswal("Warning !", "Enter NonProduction value!", "warning");
    //  return;
    //}

    // Validate ProductivtyAchieved
    if ($('#Txt_ProductivityAchieved').val() == '') {
      ngswal("Warning !", "Enter Productivity Achieved value!", "warning");
      return;
    }

    // Validate Occupancy
    if ($('#Txt_Occupancy').val() == '' || $('#Txt_Occupancy').val() == 0) {
      ngswal("Warning !", "Enter Occupancy value!", "warning");
      return;
    }

    if ($('#Txt_Punctuality').val() == '' || $('#Txt_Punctuality').val() == 0) {
      ngswal("Warning !", "Enter Punctuality value!", "warning");
      return;
    }

    if ($('#Txt_Attendance').val() == '' || $('#Txt_Attendance').val() == 0) {
      ngswal("Warning !", "Enter Attendance value!", "warning");
      return;
    }

    //if ($('#Txt_LD_Training').val() == '' || $('#Txt_LD_Training').val() == 0) {
    //  ngswal("Warning !", "Enter LD Training value!", "warning");
    //  return;
    //}

    //if ($('#Txt_APQC_Skills').val() == '' || $('#Txt_APQC_Skills').val() == 0) {
    //  ngswal("Warning !", "Enter APQC Skills value!", "warning");
    //  return;
    //}

    //if ($('#Txt_DeliverRCA_Skills').val() == '' || $('#Txt_DeliverRCA_Skills').val() == 0) {
    //  ngswal("Warning !", "Enter Deliver RCA Skills value!", "warning");
    //  return;
    //}

    if ($('#Txt_PoorRange').val() == '' || $('#Txt_PoorRange').val() == 0) {
      ngswal("Warning !", "Enter Poor Range value!", "warning");
      return;
    }

    if ($('#Txt_ModerateRange').val() == '' || $('#Txt_ModerateRange').val() == 0) {
      ngswal("Warning !", "Enter Moderate Range value!", "warning");
      return;
    }

    if ($('#Txt_GoodRange').val() == '' || $('#Txt_GoodRange').val() == 0) {
      ngswal("Warning !", "Enter Good Range value!", "warning");
      return;
    }
    if ($('#Txt_ModerateEnd').val() == '' || $('#Txt_ModerateEnd').val() == 0) {
      ngswal("Warning !", "Enter Moderate End Range value!", "warning");
      return;
    }

    
    const poorRange = Number($('#Txt_PoorRange').val());
    const moderateEnd = Number($('#Txt_ModerateEnd').val());
    const excellentRange = Number($('#Txt_ExcellentRange').val());

    if (poorRange >= moderateEnd) {
      ngswal("Warning !", "Poor Range must be less than Moderate End Range!", "warning");
      return;
    }
    if ($('#Txt_ExcellentRange').val() == '' || $('#Txt_ExcellentRange').val() == 0) {
      ngswal("Warning !", "Enter Excellent Range value!", "warning");
      return;
    }
    if (moderateEnd >= excellentRange) {
      ngswal("Warning !", "Excellent Range must be Greater than Good Range!", "warning");
      return;
    }


    // If all validations pass, show the loading popup
    //$("#LoadingImagePopup").show();

    // Gather all values from the UI and map to the Dataitem object
    var Dataitem = {
      Id: localStorage.aEID,
      RoleId: $("#ddlRoleType").val(),
      PublisherId: 0,
      NonProduction: parseFloat($("#Txt_NonProduction").val() || '0'),
      ProductivtyAchieved: parseFloat($("#Txt_ProductivityAchieved").val() || '0'),
      Occupancy: parseFloat($("#Txt_Occupancy").val() || '0'),
      Punctuality: parseFloat($("#Txt_Punctuality").val() || '0'),
      Attendance: parseFloat($("#Txt_Attendance").val() || '0'),
      //LD_Training: parseFloat($("#Txt_LD_Training").val() || '0'),
      //APQC_Skills: parseFloat($("#Txt_APQC_Skills").val() || '0'),
      //DeliverRCA_Skills: parseFloat($("#Txt_DeliverRCA_Skills").val() || '0'),
      LD_Training: 0,
      APQC_Skills: 0,
      DeliverRCA_Skills: 0,
      TotalSum: parseFloat($("#Txt_TotalSum").val() || '0'),
      PoorRange: $("#Txt_PoorRange").val(),
      // Concatenating Txt_ModerateStart and Txt_ModerateEnd
      ModerateRange: $("#Txt_ModerateStart").val() + '–' + $("#Txt_ModerateEnd").val(),
      // Concatenating Txt_GoodStart and Txt_GoodEnd
      GoodRange: $("#Txt_GoodStart").val() + '–' + $("#Txt_GoodEnd").val(),
      ExcellentRange: $("#Txt_ExcellentRange").val(),
      UpdatedBy: localStorage.aLoginID
    };
    ApiMethod.postMethod(this.modelItem.weightageRolewiseUpdateAPI, Dataitem).subscribe(
      response => {
        
        if (response.status) {
          ngswal({
            position: 'top-end',
            type: "success",
            title: "Thank You !",
            text: response.message,
            showConfirmButton: false,
            timer: 1500
          });
          this.hide();
          this.GetweightageuserwiseData();
        } else {
          ngswal({
            position: 'top-end',
            type: "error",
            title: "Failed !",
            text: response.message || "An error occurred. Please try again later.",
            showConfirmButton: true
          });
        }

        $("#LoadingImagePopup").hide();
       
      },
      error => {
        ngswal("Failed!", error.error.Message, "error");
        $("#LoadingImagePopup").hide();
      }
    );
  }



  ClearData(): void {
    $("input[type='text']").val("");
    $("input[type='number']").val("");
    $("#ddlRoleType").val(0).change();

  }
  hide(): void {
    $("#btnPopupartDetails").hide();
  }


}

